import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { EditableFieldBase } from "../editable-field-base";

export enum LayoutMode {
  Vertical,
  Horizontal  
}


@Component({
    selector: 'radio-list',
    templateUrl: './radio-list.component.html',
    styleUrls: ['./radio-list.component.scss', '../editable-fields.scss'],
    standalone: false
})
export class RadioList extends EditableFieldBase {
  @Input() layout: LayoutMode = LayoutMode.Vertical;                   // layout - default is 'vertical' other values can be: 'horizontal'    
  @Input() listOfOptions$: Observable<RadioOption[]>;

  public readOnlyValue$: Observable<string>;
  public selectedValue: any = null;

  // Add a get for layoutMode so we can use it in the html
  public get layoutMode(): typeof LayoutMode {
    return LayoutMode;
  }

  constructor() {
    super();
  }

  public ngOnInit(): void {
    super.ngOnInit();
       
    this.readOnlyValue$ = this.listOfOptions$.pipe(
      map(options => {
        var selectedOption = options.find(o => o.value == this.obj[this.prop]);
        if (selectedOption)          
          return selectedOption.label;                  
        else
          return '';
      }),
     
    );

  }

  public onClick(selectedValue) {
    this.obj[this.prop] = selectedValue;
    //  This control instance only has one event - that the option is selected.  At that point it's submitted and
    //  that is when we can run validate and change.
    this.validate();
    super.onChange();
  }
 
}

export class RadioOption {
  public value: any = null;
  public label: string = '';
  public helpText: string = '';

  constructor(value: any, label: string, helpText: string = '') {
    this.value = value;
    this.label = label;
    this.helpText = helpText;
  }
}

